var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "router-link",
        { attrs: { to: { name: "crossOrgTab", params: { tab: "orgs" } } } },
        [_vm._v("<<Back to Organizations List")]
      ),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _c("v-flex", { attrs: { xs10: "" } }, [
            _c("h3", [_vm._v("Organization: " + _vm._s(_vm.activeOrg.name))]),
          ]),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs2: "" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "mr-4 was-orange",
                  attrs: {
                    color: "primary",
                    outlined: "",
                    rounded: "",
                    disabled: _vm.activeOrg.sla !== 100,
                  },
                  on: { click: _vm.purge },
                },
                [_vm._v("Purge Org")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-form",
        {
          ref: "orgeditform",
          on: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
          model: {
            value: _vm.validOrg,
            callback: function ($$v) {
              _vm.validOrg = $$v
            },
            expression: "validOrg",
          },
        },
        [
          _c(
            "v-container",
            { attrs: { "grid-list-sm": "" } },
            [
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm5: "", md5: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { rules: [_vm.rules.required], label: "Name" },
                        on: { input: _vm.valueChanged },
                        model: {
                          value: _vm.activeOrg.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.activeOrg, "name", $$v)
                          },
                          expression: "activeOrg.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { sm2: "", md2: "" } }),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm5: "", md5: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Domain" },
                        on: { input: _vm.valueChanged },
                        model: {
                          value: _vm.activeOrg.domainName,
                          callback: function ($$v) {
                            _vm.$set(_vm.activeOrg, "domainName", $$v)
                          },
                          expression: "activeOrg.domainName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm5: "", md5: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          autofocus: false,
                          autocomplete: "off",
                          items: _vm.timeZEntries,
                          label: "Timezone",
                          rules: [_vm.rules.required],
                        },
                        on: { input: _vm.valueChanged },
                        model: {
                          value: _vm.activeOrg.timeZone,
                          callback: function ($$v) {
                            _vm.$set(_vm.activeOrg, "timeZone", $$v)
                          },
                          expression: "activeOrg.timeZone",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { sm2: "", md2: "" } }),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm5: "", md5: "" } },
                    [
                      _c("v-select", {
                        attrs: { items: _vm.slas, label: "SLA" },
                        on: { input: _vm.valueChanged },
                        model: {
                          value: _vm.activeOrg.sla,
                          callback: function ($$v) {
                            _vm.$set(_vm.activeOrg, "sla", $$v)
                          },
                          expression: "activeOrg.sla",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("v-textarea", {
                        attrs: { label: "Misc Data", rows: "2" },
                        on: { input: _vm.valueChanged },
                        model: {
                          value: _vm.activeOrg.miscData,
                          callback: function ($$v) {
                            _vm.$set(_vm.activeOrg, "miscData", $$v)
                          },
                          expression: "activeOrg.miscData",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs5: "" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.allProducts,
                          attach: "",
                          label: "Products",
                          multiple: "",
                          clearable: "",
                          "small-chips": "",
                          "deletable-chips": "",
                        },
                        on: { input: _vm.valueChanged },
                        model: {
                          value: _vm.selectedProducts,
                          callback: function ($$v) {
                            _vm.selectedProducts = $$v
                          },
                          expression: "selectedProducts",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { xs2: "" } }),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs5: "" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.allFeatures,
                          attach: "",
                          multiple: "",
                          clearable: "",
                          "small-chips": "",
                          "deletable-chips": "",
                          label: "Features",
                        },
                        on: { input: _vm.valueChanged },
                        model: {
                          value: _vm.selectedFeatures,
                          callback: function ($$v) {
                            _vm.selectedFeatures = $$v
                          },
                          expression: "selectedFeatures",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs5: "" } },
                    [
                      _c("span", { staticClass: "subheading" }, [
                        _vm._v(
                          "Available Modules (" +
                            _vm._s(_vm.filteredModules(_vm.activeOrg).length) +
                            ")"
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-list",
                        {
                          staticStyle: {
                            height: "250px",
                            "overflow-y": "scroll",
                            border: "solid grey 1px",
                          },
                          attrs: { "three-line": "", dense: "" },
                        },
                        _vm._l(
                          _vm.filteredModules(_vm.activeOrg),
                          function (rpt) {
                            return _c(
                              "v-list-item",
                              { key: rpt.id },
                              [
                                _c(
                                  "v-list-item-action",
                                  [
                                    _c("v-checkbox", {
                                      on: {
                                        change: function ($event) {
                                          return _vm.availableCheckChanged(rpt)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-list-item-content",
                                  { staticStyle: { "margin-left": "-25px" } },
                                  [
                                    _c("v-list-item-title", [
                                      _vm._v(_vm._s(rpt.displayName)),
                                    ]),
                                    _vm._v(" "),
                                    _c("v-list-item-subtitle", [
                                      _vm._v(_vm._s(rpt.description)),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticStyle: { "text-align": "center" },
                      attrs: { xs2: "" },
                    },
                    [
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on, attrs }) {
                                return [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        icon: "",
                                        disabled:
                                          _vm.selectedAvailable.length === 0,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.moveSelectedAvailableToAssigned(
                                            _vm.activeOrg
                                          )
                                        },
                                      },
                                    },
                                    [_c("v-icon", [_vm._v("fa-angle-right")])],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _c("span", [_vm._v("Assign selected modules")]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { icon: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.moveAllAvailableToAssigned(
                                            _vm.activeOrg
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", [
                                        _vm._v("fa-angle-double-right"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _c("span", [_vm._v("Assign all modules")]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        icon: "",
                                        disabled:
                                          _vm.selectedAssigned.length === 0,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.unAssignSelected(
                                            _vm.activeOrg
                                          )
                                        },
                                      },
                                    },
                                    [_c("v-icon", [_vm._v("fa-angle-left")])],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _c("span", [_vm._v("Unassign selected modules")]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { icon: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.unAssignAll(_vm.activeOrg)
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", [
                                        _vm._v("fa-angle-double-left"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _c("span", [_vm._v("Unassign all modules")]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("br"),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs5: "" } },
                    [
                      _c("span", { staticClass: "subheading" }, [
                        _vm._v(
                          "Assigned Modules (" +
                            _vm._s(_vm.activeOrg.enabledModules.length) +
                            ")"
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-list",
                        {
                          staticStyle: {
                            height: "250px",
                            "overflow-y": "scroll",
                            border: "solid grey 1px",
                          },
                          attrs: { "three-line": "", dense: "" },
                        },
                        _vm._l(_vm.activeOrg.enabledModules, function (rpt) {
                          return _c(
                            "v-list-item",
                            { key: rpt.id + _vm.rerender - _vm.rerender },
                            [
                              _c(
                                "v-list-item-action",
                                [
                                  _c("v-checkbox", {
                                    on: {
                                      change: function ($event) {
                                        return _vm.assignedCheckChanged(rpt.id)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item-content",
                                { staticStyle: { "margin-left": "-25px" } },
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(_vm._s(rpt.displayName)),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-list-item-subtitle", [
                                    _vm._v(_vm._s(rpt.description)),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-4 was-orange",
                          attrs: {
                            color: "primary",
                            outlined: "",
                            rounded: "",
                            disabled: !_vm.changed,
                          },
                          on: { click: _vm.reset },
                        },
                        [_vm._v("Reset")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "was-orange",
                          attrs: {
                            color: "primary",
                            rounded: "",
                            disabled: !_vm.changed || !_vm.validOrg,
                          },
                          on: { click: _vm.save },
                        },
                        [_vm._v("Save")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }